import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Contact from "../components/Contact";

export default withRouter(connect()(Contact));
